import {
  defineAsyncComponent,
  type AsyncComponentLoader,
  type Component,
} from 'vue'

/** Délai avant fetch du chunk pour overlays / hover (évite un flash si le module est déjà en cache). */
export const ASYNC_OVERLAY_DELAY_MS = 200

/**
 * `defineAsyncComponent` avec skeleton optionnel.
 * `suspensible: false` : le `loadingComponent` s’affiche sans `<Suspense>` parent.
 */
export function defineAsyncWithSkeleton<T extends Component>(
  loader: AsyncComponentLoader<T>,
  loadingComponent?: Component,
  delay = 0,
) {
  return defineAsyncComponent({
    loader,
    delay,
    suspensible: false,
    ...(loadingComponent ? { loadingComponent } : {}),
  })
}
